<template>
  <ion-page mode="ios">
    <!-- Header Section (Blue) -->
    <ion-header mode="ios" class="header-blue">
      <div class="header-content">
        <div class="header-search">
          <ion-searchbar
            placeholder="Belajar Apa Hari ini?"
            class="search-bar"
          ></ion-searchbar>
          <ion-button class="notification-button">
            <img
              style="width: 40px; height: 30px"
              src="../assets/Alarm.png"
              alt=""
            />
          </ion-button>
        </div>
      </div>
    </ion-header>

    <!-- Main Content Section (White) -->
    <ion-content class="home-page">
      <ion-refresher slot="fixed" @ionRefresh="doRefresh($event)">
        <ion-refresher-content />
      </ion-refresher>
      <ion-content class="ion-padding">
        <h1 class="header-title">Halo {{ fullName }}</h1> <br>
        <!-- <div class="class-info">
          <ion-label class="class-label">{{ userClass }}</ion-label>
          <ion-button class="kelas-button">Pilih Kelas</ion-button>
        </div> -->
        <!-- <ion-badge style="color: #fbbf24; margin-top: 12px; margin-left: 15px">
          Paket Belajar Juara Kelas!
        </ion-badge> -->
        <br />
        <center>
          <ion-badge class="custom-badge">
            <div class="badge-item">
              <img class="icon" src="../assets/medal.png" alt="Medal" />
              <h1 class="badge-text">1 Medal</h1>
            </div>
            <div class="badge-item">
              <img class="icon" src="../assets/hat.png" alt="Hat" />
              <h1 class="badge-text">Peringkat ke 3</h1>
            </div>
          </ion-badge>
        </center>

        <!-- Dinamis Ion Card -->
        <ion-card style="background-color: #fafafa; padding: 8px; border-radius: 12px; margin:0px;">
  <div class="image-grid" v-if="!loading" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 6px;">
    <div v-for="jadwal in jadwalCPNS" :key="jadwal.id" style="border-radius: 8px; background-color: #ffffff; padding: 8px; box-shadow: 0 2px 5px rgba(0,0,0,0.1); text-align: center; min-height: 80px; display: flex; flex-direction: column; justify-content: space-between;">
      <ion-label style="font-size: 0.75em; font-weight: bold; color: #333; margin-bottom: 5px;">
        {{ jadwal.judulUjian }}
      </ion-label>
      <ion-button @click="navigateToJadwal(jadwal)" expand="block" shape="round" size="small" style="--background: #ff6347; color: white; font-size: 0.7em;">
        Mulai
      </ion-button>
    </div>
  </div>
  <ion-spinner v-if="loading" name="crescent" style="display: block; margin: 20px auto;"></ion-spinner>
</ion-card>




        <!-- Dinamis Ion Card -->

        <img
          style="width: 207px; margin-bottom: 10px"
          src="../gama/seru.png"
          alt=""
        />

        <!-- Slider di bawah gambar -->
        <ion-slides
          pager="false"
          class="custom-slider"
          :options="sliderOptions"
        >
          <ion-slide class="slider-item">
            <img src="../gama/jj.png" alt="" />
          </ion-slide>
          <ion-slide class="slider-item">
            <img src="../gama/jj.png" alt="" />
          </ion-slide>
          <ion-slide class="slider-item">
            <img src="../gama/jj.png" alt="" />
          </ion-slide>
        </ion-slides>
      </ion-content>
      <ion-grid class="ion-padding">
        <!-- Additional content for the grid can be added here -->
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script setup>
import {
  IonPage,
  IonContent,
  IonRefresher,
  IonRefresherContent,
  IonGrid,
  IonSlides,
  IonSlide,
  IonCard,
  IonLabel,
  IonSpinner,
  IonHeader,
  IonSearchbar,
  IonButton,
  IonBadge,
} from "@ionic/vue";
import { ref, onMounted } from "vue";
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  getDoc,
} from "firebase/firestore";
import { firebaseApp } from "../views/firebase.js";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useRouter } from "vue-router";

const router = useRouter();

const navigateToJadwal = (jadwal) => {
  if (jadwal && jadwal.id) {
    router.push({
      name: "halamanujianUmum", // Nama rute harus sesuai dengan yang ada di router
      params: { jadwalId: jadwal.id }, // Mengirimkan parameter jadwalId
    });
  } else {
    console.error("Jadwal atau jadwalId tidak ditemukan");
  }
};

const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

const fullName = ref("");
const userClass = ref("");
const jadwalCPNS = ref([]); // Ganti mataPelajaran menjadi jadwalCPNS
const loading = ref(true);

const fetchUserData = async (uid) => {
  try {
    const userDoc = await getDoc(doc(db, "users", uid));
    if (userDoc.exists()) {
      const userData = userDoc.data();
      console.log("User data fetched:", userData); // Debugging

      fullName.value = userData.fullName;
      if (userData.kelas) {
        console.log("Kelas ID:", userData.kelas); // Debugging: Lihat ID kelas
        const classDoc = await getDoc(doc(db, "kelas", userData.kelas)); // Ganti 'classes' dengan 'kelas'
        if (classDoc.exists()) {
          const classData = classDoc.data();
          userClass.value = classData.name;
          console.log("Class name fetched:", classData.name); // Debugging: Lihat nama kelas
        } else {
          userClass.value = "Kelas tidak ditemukan";
          console.error("Class document not found!");
        }
      } else {
        userClass.value = "Tidak ada kelas terdaftar";
        console.log("No class ID in user data");
      }
    } else {
      console.error("User document not found!");
    }
  } catch (error) {
    console.error("Error fetching user data:", error);
  }
};

const fetchJadwalCPNS = async () => {
  try {
    console.log("Fetching jadwal CPNS...");
    const querySnapshot = await getDocs(collection(db, "jadwalcpns"));
    jadwalCPNS.value = querySnapshot.docs.map((doc) => {
      return {
        id: doc.id, // Tambahkan ID dokumen di sini
        ...doc.data(),
      };
    });
    console.log("Jadwal CPNS data fetched:", jadwalCPNS.value);
  } catch (error) {
    console.error("Error fetching jadwal CPNS:", error);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  onAuthStateChanged(auth, (user) => {
    if (user) {
      fetchUserData(user.uid);
      fetchJadwalCPNS(); // Panggil fungsi untuk mengambil jadwal CPNS
    } else {
      console.error("No user is logged in!");
    }
  });
  
});

const doRefresh = (event) => {
  const userId = auth.currentUser?.uid;
  if (userId) {
    fetchUserData(userId);
    fetchJadwalCPNS(); // Panggil fungsi untuk refresh jadwal CPNS
  }
  event.target.complete();
};

const sliderOptions = {
  slidesPerView: 1.1,
  spaceBetween: 5,
};

</script>

<style scoped>
.image-grid {
  margin-top: 15px;
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.card-image {
  margin: 10px; /* Memberikan jarak antara gambar */
  height: 80px;
  width: 72px;
}

.custom-slider {
  width: 100%;
  height: auto;
  margin-top: 0px; /* Mengurangi jarak atas slider */
}

.slider-item {
  padding: 0 5px; /* Mengurangi jarak antar slide */
}

.header-blue {
  --ion-background-color: #3b82f6; /* Warna biru */
  color: white;
}

.header-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  background-color: #3b5998; /* Warna biru untuk seluruh konten header */
}

.header-title {
  font-size: 1em;
  font-weight: bold;
  margin: 0;
  color: #3b82f6;
  margin-top: 5px;
  margin-bottom: -20px;
  margin-left: 15px;
}

.class-info {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
  margin-left: 15px;
}

.class-label {
  font-size: 1em;
  margin-right: 0px;
  color: #3b82f6;
  margin-bottom: -15px;
}

.kelas-button,
.paket-button {
  --background: #fbbf24; /* Warna kuning */
  --color: #7c2d12; /* Warna teks oranye */
  font-weight: bold;
  margin-right: -8px;
  border-radius: 12px;
  padding: 4px 12px;
  margin-top: 8px;
  margin-bottom: -10px;
}

.header-search {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.search-bar {
  --background: white;
  --placeholder-color: #9ca3af; /* Warna placeholder abu-abu */
  border-radius: 8px;
  flex-grow: 1;
  margin-right: -20px;
}

.notification-button {
  --background: transparent;
  padding: 0;
}

.custom-badge {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #3b5998; /* Warna latar belakang biru */
  color: white;
  border-radius: 10px;
  width: 90vw; /* Gunakan lebar fleksibel berbasis viewport */
  max-width: 100%; /* Tentukan lebar maksimum */
  min-width: 90%; /* Tentukan lebar minimum */
}

.badge-item {
  display: flex;
  align-items: center;
  margin: 0 5px; /* Kurangi jarak antar elemen */
}

.icon {
  width: 30px;
  height: 30px;
  margin-right: 5px; /* Kurangi jarak antar ikon dan teks */
}

.badge-text {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

@media (max-width: 480px) {
  .custom-badge {
    width: 80vw; /* Lebar lebih kecil untuk layar kecil */
    padding: 8px; /* Kurangi padding untuk layar kecil */
  }

  .badge-text {
    font-size: 16px; /* Kurangi ukuran teks untuk layar kecil */
  }

  .icon {
    width: 25px;
    height: 25px; /* Kurangi ukuran ikon untuk layar kecil */
  }
}

.custom-slider {
  margin-top: 0px;
}

.slider-item {
  padding: 0 4px; /* Mengurangi jarak antar slide */
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Tiga kolom dengan lebar yang sama */
  gap: 20px; /* Jarak antar item */
  justify-items: center;
  align-items: center;
  margin-top: 15px;
  margin-bottom: 15px;
  padding: 10px; /* Padding di dalam grid */
}

.card-image {
  height: 60px;
  width: 60px;
  object-fit: cover;
  display: block;
  margin-bottom: 8px;
}

.labell {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  display: block;
  width: 100%;
}
</style>
